/**
 * clipArt — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const clipArtPack: ToilePack = {
    slug: 'clip-art',
    category: 'clipart',
    name: 'Clip art',
    tagline: tagline('sheets', 'sets', 'styles'),
    chips: chips('sets', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'florals', label: 'Watercolor florals', subject: 'roses, peonies, eucalyptus sprigs and leaves'},
        {key: 'woodland', label: 'Woodland animals', subject: 'a fox, a hedgehog, a fawn, an owl and a mushroom'},
        {key: 'celebration', label: 'Celebration', subject: 'balloons, confetti, a gift box and bunting'},
    ],
    styles: [
        {key: 'watercolor', label: 'Watercolor', style: 'loose watercolor, wet pigment blooms', palette: 'soft edges, white paper showing', framing: 'elements isolated on white'},
        {key: 'flat', label: 'Flat vector', style: 'flat sticker-look vector, bold simple shapes', palette: 'limited cheerful palette', framing: 'elements isolated on white'},
        {key: 'inked', label: 'Hand-inked', style: 'black pen linework, cross-hatched shading', palette: 'a single spot color behind', framing: 'elements isolated on white'},
    ],
    directions: ['a christmas set instead', 'in soft pastel colors', 'one large centerpiece element'],
}
